export class PbhRequestUnserviceablePostModel {
  public RequestId?: number;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public CarrierEnum?: number;
  public FlightNo?: string;
  public ForwardDateToCarrier?: Date;
  public EstimatedDeliveryDate?: Date;
  public Ac?: string;
  public Batch?: number;
  public RemoveReasonType?: number;
  public RemoveReasonSubType?: number;
  public RemoveDateFromAc?: Date;
  public Tso?: number;
  public Cso?: number;
  public Dso?: number;
  public Tsr?: number;
  public Csr?: number;
  public Dsr?: number;
  public Tsn?: number;
  public Csn?: number;
  public Dsn?: number;
  public Tsi?: number;
  public Csi?: number;
  public Dsi?: number;
  public Status?: number;
  public Remark?: string;
  public RemovalReasonDetail?: string;
  public AdSbMod?: string;
  public Dom?: string;
  public Nla?: string;
  public Nha?: string;
  public EngineSerialNumber?: string;
  public ReplenishmentReason?: number;
  public RejectionRemark?: string;
}

export class PbhRequestUnserviceablePutModel {
  public Id?: number;
  public RequestId?: number;
  public Pn?: string;
  public Sn?: string;
  public Awb?: string;
  public CarrierEnum?: number;
  public FlightNo?: string;
  public ForwardDateToCarrier?: Date;
  public EstimatedDeliveryDate?: Date;
  public Ac?: string;
  public Batch?: number;
  public RemoveReasonType?: number;
  public RemoveReasonSubType?: number;
  public RemoveDateFromAc?: Date;
  public Tso?: number;
  public Cso?: number;
  public Dso?: number;
  public Tsr?: number;
  public Csr?: number;
  public Dsr?: number;
  public Tsn?: number;
  public Csn?: number;
  public Dsn?: number;
  public Tsi?: number;
  public Csi?: number;
  public Dsi?: number;
  public Status?: number;
  public Remark?: string;
  public RemovalReasonDetail?: string;
  public AdSbMod?: string;
  public Dom?: string;
  public Nla?: string;
  public Nha?: string;
  public EngineSerialNumber?: string;
  public UpdatedBy?: string;
  public UpdatedDate?: Date;
  public ReplenishmentReason?: number;
  public RejectionRemark?: string;
}
